<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap>
      <v-flex xs12 md5>
        <SelectCreditors
          :multiple="false"
          @selectedCreditors="id_credor = $event"
          :selected="id_credor"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 class="indigo lighten-5">
        <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="potenciais"
          :pagination.sync="paginacao"
          :rows-per-page-items="paginacao.rowsPerPageItems"
          :total-items="paginacao.total_itens"
          rows-per-page-text="Mostrar"
        >
          <template v-slot:items="lista">
            <td>{{ lista.item.creditor.name }}</td>
            <td>{{ lista.item.min_days_of_delay }}</td>
            <td>{{ lista.item.max_days_of_delay }}</td>
            <td>{{ lista.item.fee | numeral("0.[00]%") }}</td>
            <td>{{ lista.item.active ? "Sim" : "Não" }}</td>
            <td>{{ lista.item.updated_at | formatDateTime }}</td>
            <td>
              <v-menu offset-y>
                <v-icon color="deep-purple darken-1" slot="activator">more_vert</v-icon>
                <v-list class="">
                  <v-list-tile @click="abrir_editar(lista.item)">Editar</v-list-tile>
                  <v-list-tile @click="confirmar_remocao(lista.item)"
                    >Remover</v-list-tile
                  >
                </v-list>
              </v-menu>
            </td>
          </template>

          <template v-slot:no-data>
            <v-container
              fluid
              fill-height
              style="background-color: rgba(255, 255, 255, 0.5)"
            >
              <v-layout justify-center align-center v-if="esperar">
                <strong class="py-2" style="font-color: red; font-size: 14px"
                  >carregando...</strong
                >
              </v-layout>
              <v-layout justify-center align-center v-else>
                <strong class="py-2" style="font-color: red; font-size: 14px"
                  >Nenhum potencial encontrado</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog_remover"
      max-width="500px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <v-card>
        <v-card-title class="headline deep-purple white--text" primary-title>
          Remover
        </v-card-title>
        <v-card-text>
          <h3>Tem certeza que deseja remover esse elemento?</h3>
          <p>Essa ação não pode ser desfeita</p>
        </v-card-text>
        <v-divider class="deep-purple" />
        <v-card-actions class="py-2">
          <v-btn flat color="primary" @click="dialog_remover = false">Fechar</v-btn>
          <v-spacer />
          <v-btn color="deep-purple" dark @click="remover_potential" :disabled="esperar"
            >Remover</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_editar"
      max-width="700px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <EditPotentialModal
        :esperar="esperar"
        :item_edicao="item_edicao"
        @fechar="dialog_editar = false"
        @salvar="editar"
      />
    </v-dialog>

    <v-dialog
      v-model="dialog_criar"
      max-width="700px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <CreatePotentialModal
        :esperar="esperar"
        @fechar="fechar_dialog_criar()"
        @salvar="criar"
      />
    </v-dialog>

    <v-layout row wrap>
      <v-btn
        dark
        fab
        bottom
        right
        fixed
        color="deep-purple darken-2"
        @click="abrir_dialog_criar()"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import SelectCreditors from "@/components/creditor/SelectCreditors";
import PotentialService from "@/services/potential";
import EditPotentialModal from "@/views/administration/potential_components/EditPotentialModal";
import CreatePotentialModal from "@/views/administration/potential_components/CreatePotentialModal";

export default {
  components: {
    SelectCreditors,
    EditPotentialModal,
    CreatePotentialModal,
  },
  beforeMount() {
    if (Object.keys(this.$route.query).length === 0) {
      this.setar_filtros_url();
    }
    if (this.$route.query.credor) {
      this.id_credor = parseInt(this.$route.query.credor);
    }
    if (this.$route.query.potential === "new") {
      this.abrir_dialog_criar();
    }
  },
  data() {
    return {
      id_credor: "",
      potenciais: [],
      headers: [
        { text: "Credor", value: "creditor_id", width: "20%" },
        { text: "Dias mínimos de atraso", value: "min_days_of_delay", width: "15%" },
        { text: "Dias máximos de atraso", value: "max_days_of_delay", width: "15%" },
        { text: "Potencial de ganho", value: "fee", width: "15%" },
        { text: "Ativo", value: "active", width: "15%" },
        { text: "Última alteração", value: "updated_at", width: "15%" },
        { text: "", value: "ações", sortable: false, width: "5%" },
      ],
      paginacao: {
        page: 1,
        rowsPerPage: 25,
        sortBy: "updated_at",
        descending: true,
        rowsPerPageItems: [10, 25, 50, 100],
        total_itens: 0,
        total_pages: 0,
      },
      esperar: false,
      item_remover: "",
      dialog_remover: false,
      item_edicao: {},
      dialog_editar: false,
      dialog_criar: false,
    };
  },
  watch: {
    id_credor: function (depois, antes) {
      this.pegar_potentials();
    },
    paginacao: function (depois, antes) {
      this.pegar_potentials();
    },
  },
  methods: {
    setar_filtros_url() {
      const filtros = this.$store.getters.getPotentialsFilters;
      this.$router.replace({ name: "Gestão dos potenciais", query: filtros });
    },
    abrir_dialog_criar() {
      this.dialog_criar = true;
      if (this.id_credor) {
        this.$store.commit("setPotentialsFilters", {
          credor: this.id_credor,
          potential: "new",
        });
      } else {
        this.$store.commit("setPotentialsFilters", { potential: "new" });
      }
      this.setar_filtros_url();
    },
    fechar_dialog_criar() {
      this.dialog_criar = false;
      if (this.id_credor) {
        this.$store.commit("setPotentialsFilters", { credor: this.id_credor });
      } else {
        this.$store.commit("setPotentialsFilters", {});
      }
      this.setar_filtros_url();
    },
    pegar_potentials() {
      const self = this;
      this.esperar = true;

      if (this.id_credor) {
        this.$store.commit("setPotentialsFilters", {
          credor: this.id_credor,
          potential: this.$route.query.potential,
        });
        this.setar_filtros_url();
      }

      PotentialService.list(this.id_credor, this.paginacao)
        .then((retorno) => {
          self.potenciais = retorno.objects;
          self.paginacao.total_itens = retorno.num_results;
          self.paginacao.page = retorno.page;
          self.paginacao.total_pages = retorno.total_pages;
          self.esperar = false;
        })
        .catch((err) => {
          self.$store.commit("showSnackbar", "Falha ao tentar obter os potenciais.");
          console.error(err);
          self.esperar = false;
        });
    },
    confirmar_remocao(potential) {
      this.item_remover = potential;
      this.dialog_remover = true;
    },
    remover_potential() {
      const self = this;
      this.esperar = true;
      const id = this.item_remover.id;

      PotentialService.remove(id)
        .then((retorno) => {
          self.potenciais.map((p, index) => {
            if (p.id === id) {
              self.$delete(self.potenciais, index);
            }
          });
          self.dialog_remover = false;
          self.esperar = false;
        })
        .catch((err) => {
          self.$store.commit("showSnackbar", "Falha ao tentar remover este potencial.");
          console.error(err);
          self.esperar = false;
        });
    },
    abrir_editar(potential) {
      this.item_edicao = potential;
      this.dialog_editar = true;
    },
    editar(alteracoes) {
      const self = this;
      this.esperar = true;
      const id = this.item_edicao.id;
      const potential_editado = {
        id: id,
        creditor_id: this.item_edicao.creditor.id,
        active: alteracoes.active,
        fee: alteracoes.fee,
        min_days_of_delay: alteracoes.min_days_of_delay,
        max_days_of_delay: alteracoes.max_days_of_delay,
      };

      PotentialService.update(id, potential_editado)
        .then((retorno) => {
          self.potenciais.map((p, index) => {
            if (p.id === id) {
              self.$set(self.potenciais, index, retorno);
            }
          });
          self.dialog_editar = false;
          self.esperar = false;
        })
        .catch((err) => {
          self.$store.commit("showSnackbar", "Falha ao tentar editar este potencial.");
          console.error(err);
          self.esperar = false;
        });
    },
    criar(novo) {
      const self = this;
      this.esperar = true;

      PotentialService.create(novo)
        .then((retorno) => {
          self.pegar_potentials();
          self.dialog_criar = false;
          self.esperar = false;
          this.fechar_dialog_criar();
        })
        .catch((err) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao tentar salvar este potencial. Confira os dados e tente novamente"
          );
          console.error(err);
          self.esperar = false;
        });
    },
  },
};
</script>
